"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalToolboxDriveContent = void 0;
var LocalToolboxDriveContent = /** @class */ (function () {
    function LocalToolboxDriveContent(content, toolbox) {
        this.content = content;
        this.toolbox = toolbox;
    }
    LocalToolboxDriveContent.prototype.size = function () {
        return this.content.size();
    };
    LocalToolboxDriveContent.prototype.md5 = function () {
        return this.toolbox
            .md5(this.content, this.toolbox.createHexContent())
            .then(function (content) { return content.data(); });
    };
    LocalToolboxDriveContent.prototype.wait = function () {
        return this.content.wait();
    };
    return LocalToolboxDriveContent;
}());
exports.LocalToolboxDriveContent = LocalToolboxDriveContent;
